import render from "common/render-component";
import VideoModalWrapper from "common/components/video-modal-wrapper";

render(VideoModalWrapper, "#video-modal-wrapper");
